'use strict';

// bootstraping
import './Global/VueBase.js';

// common components
import './Global/Midia.js';
import './Header/Header';
import './FloatFooter/FloatFooter.js';
import './FooterNewsletter/FooterNewsletter';
import './FooterReputation/FooterReputation';
import './PageNav/PageNav.js';
import './Modal/Modal';
import UserApi from './Api/UserApi.js';
import CartApi from './Api/CartApi.js';
import './CookieAlert/CookieAlert';
import '@components/Lotbar';
import Domains from './domains.js';
import './Testimonials/Testimonials';
// update cached infos when user return to tab
let timeOutUpdate = null;

document.addEventListener('visibilitychange', function () {
  if (!document.hidden) {
    if (timeOutUpdate) {
      clearTimeout(timeOutUpdate);
    }

    timeOutUpdate = setTimeout(function () {
      CartApi.updateCart();
      UserApi.reload();
    }, 1000);
  }
});

if (document.querySelectorAll('[data-aos]').length) {
  import('aos/dist/aos').then((AOS) => {
    AOS.init({
      duration: 1000
    });
  });
}

// set domains in 'domain.js'
const appDomain = document.body.getAttribute('data-app');
if (appDomain && Domains[appDomain]) {
  Domains[appDomain]().catch((err) => console.error(err));
}
